/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleCaretDown = createReactComponent(
  "circle-caret-down",
  "IconCircleCaretDown",
  [
    ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
    ["path", { d: "M12 15l-4 -4h8z", key: "svg-1" }]
  ]
);

export { IconCircleCaretDown as default };
//# sourceMappingURL=IconCircleCaretDown.js.map
